// extracted by mini-css-extract-plugin
export var equalColumn = "_j4-0";